import { useCallback, useEffect, useReducer } from 'react'
import { useTranslation } from 'react-i18next'

import { Grid2 as Grid, Typography } from '@mui/material'

import { Divider } from 'src/common/components'
import { initialState, refreshReducer } from 'src/common/lib'
import { useApiClient } from 'src/common/providers'
import { snackbarUtils } from 'src/common/utils'

import { SearchFilter, SearchInfo } from '../components'
import { getProductClusterInfo } from '../services/searchProductServices'
import { useClusterRulesStore } from '../stores'

export default function SearchProduct(): JSX.Element {
  const { t } = useTranslation()
  const { apiClient } = useApiClient()
  const {
    mustRefetch,
    productCode,
    productGroepCode,
    setMustRefetch,
    setClusterView,
    clusterView,
  } = useClusterRulesStore()
  const [state, dispatch] = useReducer(refreshReducer, initialState)

  const fetchData = useCallback(async () => {
    if (!apiClient || state.loading) {
      return Promise.resolve()
    }
    try {
      dispatch({ type: 'PENDING' })
      const info = await getProductClusterInfo(
        apiClient,
        productCode,
        productGroepCode
      )
      setClusterView(info)
    } catch (error) {
      dispatch({ type: 'ERROR' })
      snackbarUtils.error(`${error}`)
    } finally {
      dispatch({ type: 'RESOLVED' })
    }
  }, [apiClient, productCode, productGroepCode, setClusterView, state.loading])

  useEffect(() => {
    if (mustRefetch) {
      fetchData()
      setMustRefetch(false)
    }
  }, [apiClient, fetchData, mustRefetch, setMustRefetch])

  return (
    <>
      <Grid size={12} mb={2}>
        <Typography variant='h2' sx={{ fontWeight: 'bold' }}>
          {t('common.titleDescriptions.searchProduct')}
        </Typography>
      </Grid>
      <Grid>
        <SearchFilter />
      </Grid>
      <Divider />
      <Grid size={12} mb={2}>
        {clusterView ? <SearchInfo /> : null}
      </Grid>
    </>
  )
}
